import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { Row, Col, Form, Button } from 'react-bootstrap';
import { saveOnboardingStep, getOnboardingStepData } from '../../utils/onboardingUtils';

const UsernameInput = () => {
    const [username, setUsername] = useState('');
    const [error, setError] = useState('');
    const history = useHistory();

    useEffect(() => {
        const onboardingData = getOnboardingStepData('platform');
        if (!onboardingData || !onboardingData.platform) {
            history.push('/onboarding/platform');
            return;
        }

        // Check for error state from previous attempt
        const usernameData = getOnboardingStepData('username');
        if (usernameData && usernameData.error) {
            setUsername(usernameData.username || '');
            setError(usernameData.error);
        }
    }, [history]);

    const handleInputChange = (e) => {
        setUsername(e.target.value);
        setError(''); // Clear error when user types
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        
        if (!username.trim()) {
            setError('Username cannot be empty.');
            return;
        }

        // Save username to localStorage
        saveOnboardingStep('username', { username: username.trim() });
        
        // Navigate to next step
        history.push('/onboarding/leagues');
    };

    const handleBack = () => {
        history.push('/onboarding/platform');
    };

    const getProgressPercentage = () => {
        // Username is step 2 of 8, so (2-1)/8 = 12.5%
        return 12.5;
    };

    return (
        <div className="pt-5 onboarding-section">    
            <Row className="onboarding-header">
                <Col xs={1} md={2}></Col>
                <Col xs={10} md={8}>       
                        
                    <Row className="text-center onboarding-title-row">
                        <Col className="onboarding-title">Enter Your Username</Col>
                    </Row>
                    
                    {/* Progress Bar */}
                    <Row className="mt-4">
                        <Col>
                            <div className="text-center mb-1">
                                <span className="onboarding-progress-percentage">
                                    {Math.round(getProgressPercentage())}% Complete
                                </span>
                            </div>
                            <div className="onboarding-progress">
                                <div 
                                    className="onboarding-progress-bar"
                                    style={{ width: `${getProgressPercentage()}%` }}
                                ></div>
                            </div>
                        </Col>
                    </Row>

                    <Row className="pt-4">
                        <Col>
                            <Form onSubmit={handleSubmit}>
                                <Row className="mb-4">
                                    <Col>
                                        <Form.Group>
                                            <Form.Label htmlFor="username-input" className="onboarding-input-label">
                                                Sleeper Username
                                            </Form.Label>
                                            <input
                                                type="text"
                                                id="username-input"
                                                name="username"
                                                className="form-control form-control-custom onboarding-input-field"
                                                value={username}
                                                onChange={handleInputChange}
                                                placeholder="Enter your Sleeper username"
                                                style={{ color: '#ffffff' }}
                                                aria-describedby={error ? "username-error" : undefined}
                                            />
                                            {error && (
                                                <div id="username-error" className="error-message mt-2" role="alert">
                                                    {error}
                                                </div>
                                            )}
                                        </Form.Group>
                                    </Col>
                                </Row>
                                
                                <Row className='align-items-center mt-4 justify-content-center'>
                                    <Button 
                                        type="button"
                                        onClick={handleBack}
                                        className="btn-secondary btn-lg mx-2 onboarding-nav-btn"
                                    >
                                        Back
                                    </Button>
                                    <Button 
                                        type="submit"
                                        disabled={!username.trim()}
                                        className="btn-primary-gradient btn-lg mx-2 onboarding-nav-btn"
                                    >
                                        Next →
                                    </Button>
                                </Row>
                            </Form>
                        </Col>
                    </Row>                        
                </Col>                            
            </Row>
        </div>
    );
};

export default UsernameInput;
